import { render } from "./rewardDetail.vue?vue&type=template&id=6931d142&scoped=true"
import script from "./rewardDetail.vue?vue&type=script&lang=js"
export * from "./rewardDetail.vue?vue&type=script&lang=js"

import "./rewardDetail.vue?vue&type=style&index=0&id=6931d142&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6931d142"]])

export default __exports__